<template>
  <div v-if="loggedIn && user">
    <EplNewDashboardHeader class="hidden-xs" @showGraceTxnsModal="showModal" />
    <EplNewDashboardSummary class="visible-xs" />
    <div class="bbps-header">
      <p class="bbps-header__title">Bill Payments and Recharges</p>
      <img class="bbps-header__logo" :src="bbpsImages.screenIcon" alt="BBPS Logo" />
    </div>
    <div
      class="info-message info-message--visible-xs"
      v-if="user.kycRequired || user.emandateRequired"
      :style="{background:user.backGroundColorCode}"
    >
      <p class="info-message__content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          :stroke="user.kycEmandateMessageColorCode"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12" y2="8" />
        </svg>
        <span class="info-message__content__text" :style="{color:user.kycEmandateMessageColorCode}">
          {{
          user.kycEmandateMessage
          }}
        </span>
      </p>
      <router-link
        :to="{
          name: user.kycRequired
            ? 'KYC Step 1'
            : user.emandateRequired
            ? 'eMandate'
            : false
        }"
        class="info-message__link"
      >Complete Now</router-link>
    </div>
    <transition name="bottomsheet" appear>
      <router-view></router-view>
    </transition>
    <EplNewDashboardFooter class="hidden-xs" />
    <EplNewDashboardFooterMobile class="visible-xs" @showGraceTxnsModal="showModal" />
    <div
      class="overlay"
      v-if="$route.meta.overlay == true"
      @click="$router.push({ name: 'Dashboard' })"
    ></div>
    <template v-if="message && message.showModal">
      <Overlay @on-click="unsetErrors" />
      <ConfirmationModal :message="message">
        <template v-slot:close-button>
          <button class="close-button" type="button" @click="unsetErrors">
            <img src="../../static/images/cross.svg" alt="Close Button" />
          </button>
        </template>
        <ActionButton
          v-slot:default
          v-for="(action, index) in message.actions"
          :key="index"
          @click="action.method"
          :title="action.title"
          :className="action.isPrimary ? '' : 'action-button--alternate'"
          type="button"
        />
      </ConfirmationModal>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EplNewDashboardSummary from "../components/EplNewDashboardSummary";
import EplNewDashboardHeader from "@/components/EplNewDashboardHeader";
import EplNewDashboardFooter from "@/components/EplNewDashboardFooter";
import EplNewDashboardFooterMobile from "../components/EplNewDashboardFooterMobile";
import Overlay from "../components/Overlay";
import ConfirmationModal from "../components/ConfirmationModal";
import ActionButton from "../components/ActionButton";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["loggedIn", "user", "bbpsImages"])
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "HOME"
    });
  },
  data() {
    return {
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined,
        actions: undefined,
        showModal: undefined
      }
    };
  },
  components: {
    EplNewDashboardSummary,
    EplNewDashboardHeader,
    EplNewDashboardFooter,
    EplNewDashboardFooterMobile,
    Overlay,
    ConfirmationModal,
    ActionButton
  },
  methods: {
    unsetErrors() {
      this.message = {};
    },
    showModal(link) {
      if (this.user.graceTxns === 0) {
        this.$store.dispatch("storeMixpanelEvent", {
          eventName: "BBPS_BLOCKED"
        });
        this.message = {
          value: this.user.kycEmandateMessage,
          fieldName: "generic",
          actions: [
            {
              title: "Complete Now",
              method: () =>
                this.$router.push({
                  name: this.user.kycRequired
                    ? "KYC Step 1"
                    : this.user.emandateRequired
                    ? "eMandate"
                    : false
                }),
              isPrimary: true
            }
          ],
          showModal: true,
          type: "warning"
        };
      } else {
        this.message = {
          value: this.user.kycEmandateMessage,
          fieldName: "generic",
          actions: [
            {
              title: "Complete Now",
              method: () =>
                this.$router.push({
                  name: this.user.kycRequired
                    ? "KYC Step 1"
                    : this.user.emandateRequired
                    ? "eMandate"
                    : false
                }),
              isPrimary: true
            },
            {
              title: "Later",
              method: () => this.$router.push({ path: link }),
              isPrimary: false
            }
          ],
          showModal: true,
          type: "warning"
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
}
.bottomsheet-enter-active {
  transform: translateY(0);
  transition: all 0.3s ease;
}
.bottomsheet-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.bottomsheet-enter,
.bottomsheet-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.close-button {
  background: transparent;
  border: none;
}
.info-message {
  margin: 2rem 1rem;
  padding: 1.5rem 3rem;
  display: grid;
  &__content {
    display: grid;
    grid-template-columns: auto 1fr;
    margin-bottom: 0;
    &__text {
      margin-left: 0.5rem;
    }
  }
  &__link {
    color: var(--primary-color);
    justify-self: end;
  }
  &--visible-xs {
    display: grid;
    @media only screen and (min-width: 640px) {
      display: none;
    }
  }
}
.bbps-header {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
  @media only screen and (min-width: 640px) {
    display: none;
  }

  &__title {
    font-size: 14px;
    color: #4d4d4d;
    margin-bottom: 0;
  }
  &__logo {
    width: 80px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewDashboard.vue